import { render, staticRenderFns } from "./PublicFileLogModal.vue?vue&type=template&id=2570272f"
import script from "./PublicFileLogModal.vue?vue&type=script&lang=ts"
export * from "./PublicFileLogModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports